import { Routes } from '@angular/router';

export const CONTENT_ROUTES: Routes = [
  {
    path: 'dashboard',
    loadChildren: './modules/dashboard/dashboard.module#DashboardModule'
  },
  /*{
    path: 'ProcessExtraction',
    loadChildren: './modules/process-extraction/process-extraction.module#ProcessExtractionModule'
  },*/
  {
    path: 'documents',
    loadChildren: './modules/documents/documents.module#DocumentsModule',
    data: { id_modulo: 42 }
  },
  {
    path: 'accounting',
    loadChildren: './modules/accounting/accounting.module#AccountingModule',
    data: { id_modulo: 40 }
  },
  {
    path: 'magnetic-media',
    loadChildren: './modules/magnetic-media/magnetic-media.module#MagneticMediaModule',
    data: { id_modulo: 41 }

  },
  {
    path: 'profile',
    loadChildren: './modules/profile/profile.module#ProfileModule'
  },
  {
    path: 'config',
    loadChildren: './modules/admin/admin.module#AdminModule',
    data: { id_modulo: 44 }
  },
  {
    path: 'magnetic-media/config-third/literals',
    loadChildren: './modules/admin/literals/literals.module#LiteralsModule'
  },
  {
    path: 'balance-generated',
    loadChildren: './modules/balance-history/balance-history.module#BalanceHistoryModule'
  },
  {
    path: 'magnetic-media-district',
    loadChildren: './modules/magnetic-media-district/magnetic-media-district.module#MagneticMediaDistrictModule',
    data: { id_modulo: 43 },
  },
  {
    path: 'active-resume',
    loadChildren: './modules/active-resume/active-resume.module#ActiveResumeModule',
    data: { id_modulo: 47 },
  },
  {
    path: 'reception-advanced',
    loadChildren: './modules/reception-advanced/reception-advanced.module#ReceptionAdvancedModule',
    data: { id_modulo: 48 },
  },
  {
    path: 'reception-advanced-doeq',
    loadChildren: './modules/reception-advanced-doeq/reception-advanced-doeq.module#ReceptionAdvancedDoeqModule',
    data: { id_modulo: 49 },
  },
];



// WEBPACK FOOTER //
// ./src/app/shared/routes/content-layout.routes.ts